import moment from 'moment';
import {type} from '../../supreme-core';
/*
 * 格式化数据
 */
const formatDate = (date, format) => {
  if (date === 'Invalid Date' || !date){
    return '';
  }
  let mapping = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds() // 毫秒
  };

  if (/(y+)/.test(format)){
    format = format.replace(RegExp.$1, `${date.getFullYear()}`.substr(4 - RegExp.$1.length));
  }

  for (const key in mapping){
    if (new RegExp(`(${key})`).test(format)){
      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? mapping[key] : `00${mapping[key]}`.substr(`${mapping[key]}`.length));
    }
  }

  return format;
};

const formatDateRange = (start, end) => {
  if (!start && !end){
    return '';
  }
  start = moment(start);
  end = moment(end);

  const result = {
    time: '',
    dateRange: '',
    zone: '',
    weekday: '',
    dayDiff: 0
  };

  const dayDiff = end.diff(start, 'day');

  if (dayDiff > 0){
    // 不同天
    result.dayDiff = dayDiff + 1;
    result.dateRange = `${start.format('MMM D')} - ${end.format('MMM D')}`;
  } else {
    // 同一天
    result.dateRange = start.format('MMM D');
    result.weekday = start.format('dddd');
  }
  result.time = `${start.format('HH:mm')} - ${end.format('HH:mm')}`;
  result.zone = 'UTC+1';//start.toString();
  return result;
};

// 用户个人信息展示数据
const formatProfile = profile => {
  if (!profile){
    return {
      medal: {}
    };
  }

  return {
    userId: profile.userId,
    accountId: profile.accountId,
    name: profile.alias || profile.name,
    medal: profile.medal || {},
    relationInfo: profile.relationInfo,
    showNioIcon: profile.medal ? profile.medal.is_nio_authorized : false,
    headImage: profile.head_image
  };
};

//=======================================业务数据===================================
const textArray2docList = list => {
  let result;

  if (list && list.length){
    result = {
      type: 'doc',
      content: [
        {
          type: 'ordered_list',
          attrs: {},
          content: []
        }
      ]
    };
    list.forEach(item => {
      result.content[0].content.push({
        type: 'list_item',
        attrs: {},
        content: [
          {
            type: 'paragraph',
            attrs: {},
            content: [
              {
                type: 'text',
                text: item
              }
            ]
          }
        ]
      });
    });
  }

  return result;
};
const imageCollection = (target, collection) => {
  target.content.forEach(item => {
    if (item.type === 'image'){
      collection.push(item.attrs.src);
    }
    if (item.content && item.content.length){
      imageCollection(item, collection);
    }
  });
};
// 格式化活动数据
const formatActivityData = (data, needCollection = false) => {
  let tips = null;
  let scenes = [];
  let pageImages = [];

  if (needCollection && data.cover_image){
    pageImages.push(data.cover_image);
  }

  if (data.scenes && data.scenes.length){
    scenes = data.scenes.map(item => {
      const {
        dateRange, time, zone, weekday, dayDiff
      } = formatDateRange(item.start_time * 1000, item.end_time * 1000);

      item.formatDate = {dateRange, weekday, dayDiff};
      item.formatTime = time;
      item.formatDesc = zone;
      item.disabled = !item.available;
      return item;
    });
  }
  if (data.tips && data.tips.length){
    tips = textArray2docList(data.tips);
  }
  if (needCollection && data.content){
    imageCollection(data.content, pageImages);
  }
  return {
    id: data.id,
    banner: data.cover_image,
    content: data.content,
    title: data.title,
    place: data.place || {},
    tips,
    scenes,
    registrationId: data.registration_id,
    ticketTypes: data.ticket_types || {},
    registered: data.registered,
    limit: data.acc_tickets_limit,
    cost: data.cost,
    status: data.show_status,
    publisher: formatProfile(data.publisher),
    pageImages
  };
};

// 格式化报名表单配置
const formatFormConfig = config => {
  if (!config){
    return [];
  }
  return config.map(item => {
    if (item.classifier){
      item.min = item.classifier.min_length;
      item.max = item.classifier.max_length;
      item.regex = item.classifier.regex;
      item.props = {
        limit: item.classifier.max_length
      };
      item.errorMsg = item.error_msg || {};
    }
    if (item.type === 'mobile_input' && item.default_value && typeof item.default_value === 'string'){
      item.default_value = JSON.parse(item.default_value);
    }
    return item;
  });
};

export {
  formatProfile,
  formatDate,
  formatDateRange,
  formatActivityData,
  formatFormConfig
};
